import React, { memo } from "react";

function AboutUs() {
  return <p>About Us</p>;
}

export default memo(AboutUs);
